/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import {
  Card,
  Image,
  Modal,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
} from 'react-bootstrap';
import { CheckIcon } from '@heroicons/react/solid';

const getFirstLetterOfEachWord = (text?: string) =>
  text?.match(/\b\w/g).join('')?.substr(0, 2);

export const KanbanEditMembersModal = (props: any) => {
  const {
    listId,
    id: cardId,
    show = false,
    members = [],
    availableBoardMembers = [],
  } = props;
  const [showModal, setShowModal] = useState(show);
  const [searchValue, setSearchValue] = useState('');
  const [boardMembers, setBoardMembers] = useState(
    availableBoardMembers.map((bm: any) => ({
      ...bm,
      show: true,
      isAssignedToCard: members.some((m: any) => m.id === bm.id),
    }))
  );

  const onSearchValueChange = (e: any) => {
    const newSearchValue = e.target.value;
    const searchResults = boardMembers.map((bm: any) => ({
      ...bm,
      show: bm.name.toLowerCase().includes(newSearchValue.toLowerCase()),
    }));

    setSearchValue(newSearchValue);
    setBoardMembers(searchResults);
  };

  const onMemberClick = (id: any) => {
    const boardMembersUpdated = boardMembers.map((m: any) =>
      m.id === id ? { ...m, isAssignedToCard: !m.isAssignedToCard } : m
    );
    setBoardMembers(boardMembersUpdated);
  };

  const onHide = () => {
    setShowModal(false);
    props.onHide && props.onHide();
  };

  const onSubmit = () => {
    const membersSelected = boardMembers.filter((m: any) => m.isAssignedToCard);
    const payload = { listId, cardId, members: membersSelected };

    return props.onSubmit && props.onSubmit(payload);
  };

  const renderImageIf = (m: any) => {
    if (m?.image) {
      return <Image src={m?.image} className="avatar-md rounded-circle" />;
    }
    if (m?.name) {
      return (
        <div className="avatar-md rounded fw-bold bg-tertiary align-items-center justify-content-center">
          <p
            style={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {getFirstLetterOfEachWord(m.name)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <Modal
      as={Modal.Dialog}
      centered
      scrollable
      show={showModal}
      onHide={onHide}
    >
      <Form className="modal-content p-3">
        <Modal.Header className="border-0 px-3 pb-0">
          <Modal.Title className="fw-normal">Suppliers</Modal.Title>
          <Button variant="close" onClick={onHide} />
        </Modal.Header>

        <Modal.Body className="px-3 pb-0">
          <Form.Group id="search" className="mb-3">
            <InputGroup className="search-bar">
              <Form.Control
                type="text"
                placeholder="Search your suppliers.."
                value={searchValue}
                onChange={onSearchValueChange}
              />
            </InputGroup>
          </Form.Group>

          <div className="px-3">
            {boardMembers
              .filter((m: any) => m.show)
              .map((m: any) => (
                <Row
                  key={`board-member-${m.id}`}
                  className="kanban-card-member border-bottom py-2"
                  onClick={() => onMemberClick(m.id)}
                >
                  <Col xs={2}>{renderImageIf(m)}</Col>
                  <Col
                    xs={8}
                    className="d-flex align-items-center justify-content-start"
                  >
                    <h4 className="fs-6 text-dark mb-0">{m.name}</h4>
                  </Col>
                  {m.isAssignedToCard && (
                    <Col xs={2} className="d-flex align-items-center">
                      <CheckIcon className="icon icon-sm text-success" />
                    </Col>
                  )}
                </Row>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0 pb-0">
          <Button
            variant="secondary"
            className="d-inline-flex align-items-center"
            onClick={onSubmit}
          >
            Confirm Suppliers
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
